import { useT } from '@/i18n/useT';
import { availableLocales, setLocale, LOCALE_NAMES, type Locale } from '@/i18n';

/**
 * Language picker.
 *
 * Deliberately available SIGNED OUT as well as signed in: a customer who reads
 * Haitian Creole needs to change the language before they can sign up, not
 * after. Putting it only behind the account menu would mean the people who need
 * it most never reach it.
 *
 * Renders nothing while only one language exists, so it stays invisible until
 * Phase 8 adds the rest rather than showing a pointless one-item control.
 */
export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { t, locale } = useT();
  const locales = availableLocales();
  if (locales.length < 2) return null;

  return (
    <label className={`lang-switch ${className}`.trim()}>
      <span className="sr-only">{t('nav.language')}</span>
      <select
        className="lang-select"
        value={locale}
        aria-label={t('nav.language')}
        onChange={(e) => setLocale(e.target.value as Locale)}
      >
        {locales.map((l) => (
          <option key={l} value={l}>
            {LOCALE_NAMES[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
